__turbopack_context__.v({
  "root": "AnimateFlip-module__wnS5mq__root",
});
